export default __webpack_public_path__ + "static/media/NIE_touchpoint_08.7755d348.mp4";